import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import Table from "../components/Table";
import filePDF from "../assets/images/file-pdf.svg";
import api from "../utils/api";
import * as am5 from "@amcharts/amcharts5";
import Chart from "../components/Chart";
import FundsCard from "../components/FundsCard";
import TableSorting from "../components/TableSorting";
import ObjectiveBox from "../components/ObjectiveBox";
import CarouselCard from "../components/CarouselCard";
import PdfDownloader from "../components/PdfDownloader";

const GetMoney = () => {
  const [horizontalChartsData, setHorizontalChartsData] = useState([]);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const calculateTotalAmount = (arrayObject) => {
    return arrayObject.reduce((total, item) => {
      const coversSum = item.Covers.reduce(
        (sum, cover) => sum + parseFloat(cover.PREMIUME_AMOUNT_IN_NIS),
        0
      );
      return total + coversSum;
    }, 0);
  };

  let colorIndex = 0;
  const getRandomGreenToBlueColor = () => {
    const colors = [
      "#0072E0",
      "#158EA5",
      "#88D892",
      "#5DC8DE",
      "#AD8EE1",
      "#C58EE1",
      "#8EE1D6",
      "#A6E18E",
      "#D8E18E",
      "#DE5DDA",
    ];
    const color = colors[colorIndex % colors.length];
    colorIndex++;
    return am5.color(color);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await api.get(
          `${process.env.REACT_APP_BE_BASE_URL}policy/insurance-policies`,
          {
            headers: {
              Authorization: `JWT ${token}`,
            },
          }
        );
        setData(response.data.data);

        const transformedData = response.data.data.map((element) => ({
          category: "מוות מתאונה",
          value: element.Covers.reduce(
            (sum, item) => sum + parseFloat(item.PREMIUME_AMOUNT_IN_NIS),
            0
          ),
          settings: {
            fill: getRandomGreenToBlueColor(),
          },
        }));

        let arrayDataForChart = [
          {
            id: `chart-${response.data.data.length}`,
            title: "Not fixed",
            total: calculateTotalAmount(response.data.data),
            totalLabel: "סך הכל מזומן",
            data: transformedData,
          },
          {
            id: `chart-${response.data.data.length}`,
            title: "Not fixed",
            total: calculateTotalAmount(response.data.data),
            totalLabel: "סך הכל מזומן",
            data: transformedData,
          },
        ];
        setHorizontalChartsData(arrayDataForChart);
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const [tableHeader, setTableHeader] = useState([
      { label: "לוגו", sortable: false, engTrns: "logo" },
      { label: "מספר פוליסה", sortable: true, engTrns: "field1" },
      { label: "סוג פוליסה", sortable: true, engTrns: "field2" },
      { label: "סטטוס", sortable: true, engTrns: "field3" },
      { label: "הפקדה אחרונה", sortable: false, engTrns: "field4" },
      { label: "סך חיסכון", sortable: false, engTrns: "field5" },
      { label: "תאריך נזילות", sortable: false, engTrns: "field6" },
      { label: "שיעור תשואה", sortable: false, engTrns: "field7" },
      { label: "שיעור דמי ניהול", sortable: false, engTrns: "field8" },
      { label: "", sortable: false, engTrns: "field9" },
    ]);

  const captureScreen = () => {
    window.print();
  };

  const [UserData, setUserData] = useState({});
  const getUser = async () => {
    try {
      const UserProfile = await api.get("/user/get_user");
      if (UserProfile.status === 200) {
        setUserData(UserProfile.data.data);
      } else {
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
      getUser();
    }
  }, []);

  return (
    <>
      <div className="heading-wrap d-flex justify-content-between">
        <div className="heading">
          <div className="head-wrap">
            <Breadcrumbs className="breadcrumbs" aria-label="breadcrumb">
              <Link to="/profile" underline="hover">
                {UserData.full_name}
              </Link>
              <Typography>
                <b>לקבל כסף</b>
              </Typography>
            </Breadcrumbs>
            <h1>ברוכים השבים , {UserData.full_name}</h1>
          </div>
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="GetMoney.pdf">
              <img src={filePDF} alt="" />
            </PdfDownloader>
          </div>
           <p>
  ברוכים הבאים ללוח הבקרה הפיננסי שלכם! כאן תוכלו לגלות את כל המידע הדרוש
  לתכנון ולניהול של הפרישה שלכם!
  <br />
  עמוד זה מציע מבט מקיף על המצב הכלכלי שלכם, תוכלו להבין כמה כסף צברתם עד היום,
  כמה מתוכו נמצא בקרנות הפנסיה וקופות הגמל, חסכון וכו׳.
  <br />
  בנוסף תוכלו לקבל תמונה מקיפה על הקצבאות והצבירות בחשבונות שלכם,
  חסכונות והשקעות. תקבלו תובנות חשובות על נתוני הפנסיה, תזהו הזדמנויות
  לחיסכון נוסף ותוכלו לעקוב אחר ההתקדמות שלכם לעבר היעדים הפיננסיים.
  עם טיפים מותאמים אישית ותצוגה ברורה של הנתונים הכלכליים שלכם,
  תוכלו לקבל החלטות מושכלות ולשלוט בעתיד הפיננסי שלכם.
</p>
        </div>
        <div className="btns-row">
          {/* <Button className="btn btn-img" size="medium" variant="contained" onClick={captureScreen}>
            <img src={filePDF} alt="" /> הפקת דוח
          </Button> */}
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="GetMoney.pdf">
              <img src={filePDF} alt="" /> הפקת דוח
            </PdfDownloader>
          </div>
        </div>
      </div>

      {/* <Table
        tableHeader={tableHeader}
        data={data}
        from="insurencePolicies"
        title="ביטוחי חיים ובריאות"
      /> */}
      <Table
        tableHeader={tableHeader}
        data={data}
        from="savingPage"
        title="אפשרויות משיכה"
        notFoundMessage="Get Money"
      />
    </>
  );
};

export default GetMoney;
